import { useState } from "react";

import { useForm, Controller } from "react-hook-form";
import { useLocation } from "react-router-dom";

import CloseIcon from "@mui/icons-material/Close";
import {
  Autocomplete,
  Box,
  Button,
  Modal,
  Switch,
  TextField,
  Typography,
} from "@mui/material";

import { handleCreateErrors } from "../../../components/utils/errors"

import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import useGetUnlimitedListOf from "../../../hooks/useGetUnlimitedListOf";


const Create = ({ handleOpen, open }) => {
  const axiosPrivate = useAxiosPrivate();
  const location = useLocation();

  const table = "Notifications";

  const [selectedmessage_code, setSelectedmessage_code] = useState(null);
  const [selecteduser_to_code, setSelecteduser_to_code] = useState(null);
  const messagesTemp = useGetUnlimitedListOf("Messages", "", "list");
  const messagesData = messagesTemp.listElements;

  const usersTemp = useGetUnlimitedListOf("Users", "", "list");
  const usersData = usersTemp.listElements;

  const columns = ["code", "message_code", "user_to_code", "url", "read"];

  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm();

  const create = async (formData) => {
if (!formData.message_code?.trim() || !formData.user_to_code?.trim()) {
    window.alert("message_code, user_to_code non possono essere vuoti!");
    return;
  }


	 const errors = {}
	 const apiCall = `/${table}/create`
    try {
      const response = await axiosPrivate.post(apiCall, formData);
      if (!response) throw new Error("Errore nella creazione");

      window.alert("Creazione avvenuta con successo")

    } catch (error) {
    errors.call = apiCall;
    errors.callData = formData;
    errors.error = error;
    errors.forceReload = false;

    handleCreateErrors(errors, true)

    }
  };

  return (
    <>
      <Modal open={open}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            display: "flex",
            flexDirection: "column",
          }}
          alignItems={"center"}
        >
          <Box display={"flex"} justifyContent={"space-between"} sx={{ mb: 2 }}>
            <Typography
              id="keep-mounted-modal-title"
              variant="h6"
              component="h2"
            >
              Crea un nuovo elemento per la tabella {table}
            </Typography>
            <Button
              color="error"
              onClick={() => handleOpen(false, "create")}
              sx={{
                maxWidth: "30px",
                maxHeight: "30px",
                minWidth: "30px",
                minHeight: "30px",
              }}
            >
              <CloseIcon />
            </Button>
          </Box>
          <Box
            display={"flex"}
            justifyContent={"center"}
            sx={{ width: "100%" }}
          >
            {/* Autocomplete per il campo message_code */}
            <Autocomplete
              sx={{ width: "50%", m: 1 }}
              options={messagesData}
              getOptionLabel={(option) => option.message || option.code}
              value={
                selectedmessage_code
                  ? messagesData.find((comunication) => comunication.code === selectedmessage_code)
                  : null
              }
              onChange={(event, newValue) => {
                if (newValue) {
                  setSelectedmessage_code(newValue.code);
                  setValue("message_code", newValue.code);
                }
              }}
              isOptionEqualToValue={(option, value) =>
                option.code === value.code
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select message_code"
                  placeholder="message_code"
                  error={!!errors.message_code}
                  helperText={
                    errors.message_code ? "Il campo message_code è obbligatorio" : ""
                  }
                />
              )}
            />
          </Box>
          <Box
            display={"flex"}
            justifyContent={"center"}
            sx={{ width: "100%" }}
          >
            {/* Autocomplete per il campo user_to_code */}
            <Autocomplete
              sx={{ width: "50%", m: 1 }}
              options={usersData}
              getOptionLabel={(option) => option.email || option.code}
              value={
                selecteduser_to_code
                  ? usersData.find((user) => user.code === selecteduser_to_code)
                  : null
              }
              onChange={(event, newValue) => {
                if (newValue) {
                  setSelecteduser_to_code(newValue.code);
                  setValue("user_to_code", newValue.code);
                }
              }}
              isOptionEqualToValue={(option, value) =>
                option.code === value.code
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select user_to_code"
                  placeholder="user_to_code"
                  error={!!errors.user_to_code}
                  helperText={
                    errors.user_to_code ? "Il campo user_to_code è obbligatorio" : ""
                  }
                />
              )}
            />
          </Box>

          {/* Altri campi */}
          {columns
            .filter((column) => column !=="code" && column !== "message_code" && column !== "user_to_code" && column !== "read")
            .map((column, index) => (
              <TextField
                key={index}
                placeholder={column}
                sx={{ width: "50%", m: 1 }}
                {...register(column)}
              />
            ))}

{/* switch per campo read */}
<Controller
      name="read"
      control={control}
      defaultValue={false}
      render={({ field }) => (
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Typography sx={{ mr: 2 }}>read:</Typography>
          <Switch color="primary" {...field} checked={field.value} />
        </Box>
      )}
    />


          <Button onClick={handleSubmit(create)}>CREA ENTRY</Button>
        </Box>
      </Modal>
    </>
  );
};

export default Create;